// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalendpointsModelSummary } from './InternalendpointsModelSummary';
import {
  InternalendpointsModelSummaryFromJSON,
  InternalendpointsModelSummaryFromJSONTyped,
  InternalendpointsModelSummaryToJSON,
  InternalendpointsModelSummaryToJSONTyped,
} from './InternalendpointsModelSummary';

/**
 *
 * @export
 * @interface InternalendpointsListModelsResponse
 */
export interface InternalendpointsListModelsResponse {
  /**
   *
   * @type {Array<InternalendpointsModelSummary>}
   * @memberof InternalendpointsListModelsResponse
   */
  models?: Array<InternalendpointsModelSummary>;
  /**
   *
   * @type {number}
   * @memberof InternalendpointsListModelsResponse
   */
  totalCount?: number;
}

/**
 * Check if a given object implements the InternalendpointsListModelsResponse interface.
 */
export function instanceOfInternalendpointsListModelsResponse(
  value: object,
): value is InternalendpointsListModelsResponse {
  return true;
}

export function InternalendpointsListModelsResponseFromJSON(
  json: any,
): InternalendpointsListModelsResponse {
  return InternalendpointsListModelsResponseFromJSONTyped(json, false);
}

export function InternalendpointsListModelsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalendpointsListModelsResponse {
  if (json == null) {
    return json;
  }
  return {
    models:
      json['models'] == null
        ? undefined
        : (json['models'] as Array<any>).map(
            InternalendpointsModelSummaryFromJSON,
          ),
    totalCount: json['total_count'] == null ? undefined : json['total_count'],
  };
}

export function InternalendpointsListModelsResponseToJSON(
  json: any,
): InternalendpointsListModelsResponse {
  return InternalendpointsListModelsResponseToJSONTyped(json, false);
}

export function InternalendpointsListModelsResponseToJSONTyped(
  value?: InternalendpointsListModelsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    models:
      value['models'] == null
        ? undefined
        : (value['models'] as Array<any>).map(
            InternalendpointsModelSummaryToJSON,
          ),
    total_count: value['totalCount'],
  };
}
